import React, { FC } from 'react'
import { NavLink } from 'react-router-dom'

import { Button, Card, LoadingSpinner, Notice } from '../../components'
import { LeaveOfAbsence } from '../../entities/LeaveOfAbsences/LeaveOfAbsences'
import trans from '../../helpers/trans'
import { leaveOfAbsenceStatus, LeaveOfAbsenceStatusTypes } from '../../types/LeaveOfAbsenceStatusTypes'
import { LeaveOfAbsenceDetailList } from './subcomponents/index'

import './LeaveOfAbsenceDetailContainer.scss'

interface LeaveOfAbsenceDetailContainerProps {
    cancelLeaveOfAbsence: (id: string) => void;
    leaveOfAbsence?: LeaveOfAbsence;
    isLoading: boolean;
    className?: string;
}

const LeaveOfAbsenceDetailContainer: FC<LeaveOfAbsenceDetailContainerProps> = ({
    cancelLeaveOfAbsence,
    leaveOfAbsence,
    isLoading,
    className = '',
}) => {
    const emptyState = ! leaveOfAbsence || Object.keys(leaveOfAbsence).length === 0

    const status = leaveOfAbsence ? leaveOfAbsence.status : {} as LeaveOfAbsenceStatusTypes
    const { color } = leaveOfAbsenceStatus[status] || {}

    const isAbsenceRequestOpen = status === LeaveOfAbsenceStatusTypes.open
    const isAbsenceRequestApproved = status === LeaveOfAbsenceStatusTypes.approved
    const hasPendingChangeset = leaveOfAbsence?.hasPendingChangeset
        && leaveOfAbsence?.changeset?.start
        && leaveOfAbsence?.changeset?.end

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <div className={`leave-of-absence-detail ${className}`}>
            <Card
                color={color}
                className="leave-of-absence-detail__card"
            />

            {hasPendingChangeset && (
                <Notice type="warning">
                    {trans('containers.leaveOfAbsenceDetailContainer.pendingChangesetOriginalNotice')}
                </Notice>
            )}

            {! isLoading && ! emptyState && (
                <LeaveOfAbsenceDetailList
                    leaveOfAbsence={leaveOfAbsence}
                />
            )}

            {isAbsenceRequestOpen && (
                <Button
                    text={trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceRequestRevoke')}
                    className="leave-of-absence-detail__cancel-button"
                    onClick={() => cancelLeaveOfAbsence(leaveOfAbsence?.id || '')}
                />
            )}

            {isAbsenceRequestApproved && (
                <NavLink
                    to={`/${trans('nav.absences.link')}/${leaveOfAbsence?.id || ''}/${trans('common.edit')}`}
                    className="leave-of-absence-detail__edit-button"
                >
                    {trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceRequestAlter')}
                </NavLink>
            )}
        </div>
    )
}

export default LeaveOfAbsenceDetailContainer
